export default __webpack_public_path__ + "static/media/osto-logo.4ed60ec6.png";